export default __webpack_public_path__ + "static/media/youth-led.baf2c609.svg";